import React from "react";

const VariantIdRenderer = (props) => {
  // check if the value starts with "rs" and if not, return the value as is
  if (!props.value || !props.value.startsWith("rs")) {
    return props.value;
  }
  const baseUrl = "https://www.ncbi.nlm.nih.gov/snp/?term=";
  const link = `${baseUrl}${props.value}`;

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {props.value}
    </a>
  );
};

export default VariantIdRenderer;
